import React, { useEffect, useRef, useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import CustomModal from "components/Common/CustomModal";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { ACCESS } from "constants/variable";

const SidebarContent = props => {
  const [role, setRole] = useState("");
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
  const userRole = localStorage.getItem("userRole");
  const navigate = useNavigate();

  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();

  const urlParams = new URLSearchParams(path.search);
  let currentTab = path.pathname === '/parent-dashboard' ? urlParams.get('tab') : null;
  if (path.pathname === '/parent-dashboard' && !currentTab) {
    const savedTab = localStorage.getItem("activeTab") || '0';
    const TAB_ID_TO_PARAM = {
      '0': 'dashboard',
      '1': 'child-details',
      '2': 'fee-details',
      '3': 'payment-history',
      '4': 'program-change-history',
      '5': 'parent-meeting'
    };
    currentTab = TAB_ID_TO_PARAM[savedTab] || 'dashboard';
  }

  const activeMenu = useCallback(() => {
    if (userRole === "parent") return;
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");

    const sidebarPageMapping = {
      "/edit-parent": "/parent-list",
      "/add-parent": "/parent-list",
      "/add-parent-registration": "/registration",
      "/add-student": "/student",
      "/edit-student": "/student",
      "/add-users": "/users",
      "/edit-users": "/users",
      "/add-cluster": "/cluster",
      "/edit-cluster": "/cluster",
      "/add-program-type": "/program-type",
      "/edit-program-type": "/program-type",
      "/add-category": "/category",
      "/edit-category": "/category",
      "/add-centre": "/centre",
      "/edit-centre": "/centre",
      "/add-feestructure": "/feestructure",
      "/edit-feestructure": "/feestructure",
      "/add-discount": "/discount",
      "/edit-discount": "/discount",
      "/add-academicyear": "/academic-year",
      "/edit-academicyear": "/academic-year",
      "/add-payment": "/payment",
      "/edit-payment": "/payment",
      "/student-payment-allocation": "/payment",
      "/fees-paid": "/fees-paid",
      "/edit-fees-paid": "/fees-paid",
      "/edit-registration": "/registration",
      "/add-feetype": "/fees-type",
      "/edit-feetype": "/fees-type",
      "/apply-late-fee": "/apply-late-fee",
      "/view-payment-status": "/payment-status",
      "/edit-observation": "/observation",
      "/student-discount-allocation": "/discount",
      "/student-discount-unallocation": "/discount",
      "/student-feetype-allocation": "/fees-type",
      "/student-feetype-unallocation": "/fees-type"
    };
    removeActivation(items);

    if (sidebarPageMapping[pathName]) {
      for (let i = 0; i < items.length; ++i) {
        if (items[i].pathname === sidebarPageMapping[pathName]) {
          matchingMenuItem = items[i];
          break;
        }
      }
    } else {
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
    }
    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    if (userRole !== "parent") {
      new MetisMenu("#side-menu");
    }
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  // Dynamic flyout positioning for collapsed sidebar
  useEffect(() => {
    const sideMenu = document.getElementById("side-menu");
    if (!sideMenu) return;

    const handleMouseEnter = (e) => {
      const li = e.currentTarget;
      if (!document.body.classList.contains("vertical-collpsed")) return;

      requestAnimationFrame(() => {
        const liRect = li.getBoundingClientRect();
        const aHeight = liRect.height;
        const ul = li.querySelector(":scope > ul");
        const ulHeight = ul ? ul.offsetHeight : 0;
        const flyoutHeight = aHeight + ulHeight;
        const viewportHeight = window.innerHeight;
        const safeMargin = 10;

        const spaceBelow = viewportHeight - liRect.bottom - safeMargin;
        let shift = 0;

        if (flyoutHeight > spaceBelow) {
          shift = flyoutHeight - spaceBelow;
          if (liRect.top - shift < safeMargin) {
            shift = Math.max(0, liRect.top - safeMargin);
          }
        }
        li.style.setProperty("--flyout-shift", `${-shift}px`);
      });
    };

    const handleMouseLeave = (e) => {
      e.currentTarget.style.removeProperty("--flyout-shift");
    };

    const topLevelItems = sideMenu.querySelectorAll(":scope > li");
    topLevelItems.forEach(li => {
      li.addEventListener("mouseenter", handleMouseEnter);
      li.addEventListener("mouseleave", handleMouseLeave);
    });

    return () => {
      topLevelItems.forEach(li => {
        li.removeEventListener("mouseenter", handleMouseEnter);
        li.removeEventListener("mouseleave", handleMouseLeave);
      });
    };
  }, [userRole]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  useEffect(() => {
    const storedRole = localStorage.getItem("userRole");
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);

  const handleSidebarClick = (e) => {
    const link = e.target.closest("a");
    if (link && window.innerWidth <= 992) {
      if (!link.classList.contains("has-arrow")) {
        document.body.classList.remove("sidebar-enable");
      }
    }
  };

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu" onClick={handleSidebarClick}>
          <ul className="metismenu list-unstyled" id="side-menu">
            {userRole === "parent" && (
              <>
                <style>{`
                  .parent-sidebar,
                  .vertical-menu.parent-sidebar,
                  .vertical-collpsed .parent-sidebar,
                  .vertical-collpsed .vertical-menu.parent-sidebar,
                  body.vertical-collpsed .vertical-menu.parent-sidebar,
                  body[data-sidebar="dark"] .vertical-menu.parent-sidebar,
                  body[data-sidebar="dark"].vertical-collpsed .vertical-menu.parent-sidebar {
                    background: var(--talc-bg-card) !important;
                    background-color: var(--talc-bg-card) !important;
                    border-right: 1px solid var(--talc-primary-light) !important;
                  }
                  .parent-sidebar .navbar-brand-box,
                  .vertical-collpsed .parent-sidebar .navbar-brand-box,
                  body[data-sidebar="dark"] .parent-sidebar .navbar-brand-box,
                  body[data-sidebar="dark"].vertical-collpsed .parent-sidebar .navbar-brand-box {
                    background: var(--talc-bg-card) !important;
                    background-color: var(--talc-bg-card) !important;
                    border-bottom: 1px solid var(--talc-primary-light) !important;
                  }
                  .parent-sidebar .sidebar-background,
                  .parent-sidebar .simplebar-content-wrapper,
                  .parent-sidebar .simplebar-content,
                  .parent-sidebar .simplebar-mask,
                  .parent-sidebar [data-simplebar],
                  .vertical-collpsed .parent-sidebar .sidebar-background,
                  .vertical-collpsed .parent-sidebar .simplebar-content-wrapper,
                  .vertical-collpsed .parent-sidebar .simplebar-content,
                  .vertical-collpsed .parent-sidebar .simplebar-mask,
                  .vertical-collpsed .parent-sidebar [data-simplebar],
                  .parent-sidebar #sidebar-menu,
                  .parent-sidebar #sidebar-menu ul,
                  .parent-sidebar #sidebar-menu > ul,
                  .vertical-collpsed .parent-sidebar #sidebar-menu,
                  .vertical-collpsed .parent-sidebar #sidebar-menu ul,
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul,
                  body[data-sidebar="dark"].vertical-collpsed .parent-sidebar #sidebar-menu ul {
                    background: var(--talc-bg-card) !important;
                    background-color: var(--talc-bg-card) !important;
                  }
                  .parent-sidebar #sidebar-menu ul li a {
                    display: flex !important;
                    align-items: center !important;
                    color: var(--talc-text-secondary) !important;
                    margin: 4px 12px !important;
                    padding: 9px 14px !important;
                    border-radius: 10px !important;
                    font-weight: 500 !important;
                    background: transparent !important;
                    background-color: transparent !important;
                    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out !important;
                  }
                  .parent-sidebar #sidebar-menu ul li a i {
                    color: var(--talc-text-muted) !important;
                    font-size: 1.1rem !important;
                    transition: color 0.2s ease-in-out !important;
                  }
                  .parent-sidebar #sidebar-menu ul li a.active,
                  .parent-sidebar #sidebar-menu ul li a:hover {
                    color: var(--talc-primary) !important;
                    background: var(--talc-primary-light) !important;
                    background-color: var(--talc-primary-light) !important;
                  }
                  .parent-sidebar #sidebar-menu ul li a.active i,
                  .parent-sidebar #sidebar-menu ul li a:hover i {
                    color: var(--talc-primary) !important;
                  }
                  .parent-sidebar #sidebar-menu > ul {
                    padding-bottom: 10px !important;
                    min-height: calc(100vh - 80px);
                    display: flex;
                    flex-direction: column;
                  }
                  .parent-sidebar #sidebar-menu > ul > li.parent-logout-item {
                    margin-top: auto !important;
                    position: static !important;
                  }
                  .parent-sidebar #sidebar-menu > ul > li.parent-logout-item > a {
                    color: var(--talc-danger) !important;
                    background: transparent !important;
                  }
                  .parent-sidebar #sidebar-menu > ul > li.parent-logout-item > a i {
                    color: var(--talc-danger) !important;
                  }
                  .parent-sidebar #sidebar-menu > ul > li.parent-logout-item > a:hover {
                    background-color: var(--talc-danger-bg) !important;
                    color: var(--talc-danger-text) !important;
                  }
                  .parent-sidebar #sidebar-menu > ul > li.parent-logout-item > a:hover i {
                    color: var(--talc-danger-text) !important;
                  }
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li > a,
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li:hover > a {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    width: 50px !important;
                    min-height: 48px !important;
                    margin: 4px 10px !important;
                    padding: 0 !important;
                    border-radius: 12px !important;
                    overflow: hidden !important;
                    background: transparent !important;
                    background-color: transparent !important;
                  }
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li > a.active,
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li:hover > a {
                    background: var(--talc-primary-light) !important;
                    background-color: var(--talc-primary-light) !important;
                    color: var(--talc-primary) !important;
                  }
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li.parent-logout-item > a,
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li.parent-logout-item:hover > a {
                    width: 50px !important;
                    margin: 4px 10px !important;
                    background: transparent !important;
                  }
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li.parent-logout-item:hover > a {
                    background: var(--talc-danger-bg) !important;
                    background-color: var(--talc-danger-bg) !important;
                    color: var(--talc-danger-text) !important;
                  }
                  .vertical-collpsed .parent-sidebar .navbar-brand-box {
                    background: var(--talc-bg-card) !important;
                    border-bottom: 1px solid var(--talc-primary-light) !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                  }
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li > a i,
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li:hover > a i {
                    min-width: auto !important;
                    margin: 0 !important;
                  }
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li > a.active i,
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li:hover > a i {
                    color: var(--talc-primary) !important;
                  }
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li.parent-logout-item > a i {
                    color: var(--talc-danger) !important;
                  }
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li.parent-logout-item:hover > a i {
                    color: var(--talc-danger-text) !important;
                  }
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li > a span,
                  .vertical-collpsed .parent-sidebar #sidebar-menu > ul > li:hover > a span {
                    display: none !important;
                  }
                  .logo-dark {
                    display: none !important;
                  }
                  .logo-light {
                    display: block !important;
                  }
                  .logo-light img {
                    display: block !important;
                    max-width: 100%;
                    object-fit: contain;
                  }
                `}</style>
                <li>
                  <Link to="/parent-dashboard?tab=dashboard" className={currentTab === "dashboard" ? "active" : ""}>
                    <i className="bx bx-grid-alt"></i>
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/parent-dashboard?tab=child-details" className={currentTab === "child-details" ? "active" : ""}>
                    <i className="bx bx-face"></i>
                    <span>{props.t("Child Details")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/parent-dashboard?tab=fee-details" className={currentTab === "fee-details" ? "active" : ""}>
                    <i className="bx bx-receipt"></i>
                    <span>{props.t("Fee Details")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/parent-dashboard?tab=payment-history" className={currentTab === "payment-history" ? "active" : ""}>
                    <i className="bx bx-history"></i>
                    <span>{props.t("Payment History")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/parent-dashboard?tab=program-change-history" className={currentTab === "program-change-history" ? "active" : ""}>
                    <i className="bx bx-transfer"></i>
                    <span>{props.t("Previous Payment")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/parent-dashboard?tab=parent-meeting" className={currentTab === "parent-meeting" ? "active" : ""}>
                    <i className="bx bx-calendar-event"></i>
                    <span>{props.t("Meetings")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/profile" className={path.pathname === "/profile" ? "active" : ""}>
                    <i className="bx bx-cog"></i>
                    <span>{props.t("Profile Settings")}</span>
                  </Link>
                </li>
                <li className="parent-logout-item">
                  <Link
                    to="/logout"
                    onClick={(event) => {
                      event.preventDefault();
                      setLogoutConfirmOpen(true);
                    }}
                  >
                    <i className="bx bx-log-out"></i>
                    <span>{props.t("Logout")}</span>
                  </Link>
                </li>
              </>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <>
                <li>
                  <Link to={`/dashboard`}>
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>
              </>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-money"></i>
                  <span>{props.t("Registration")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/registration">
                      <i className="bx bx-detail"></i>
                      <span>{props.t("Student Registration")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/observation">
                      <i className="bx bx-clipboard"></i>
                      <span>{props.t("Observation")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            {ACCESS.ALL_CENTRE_ACCESS.includes(userRole) && (
              <li>
                <Link to="/student">
                  <i className="bx bx-group"></i>
                  <span>{props.t("Student")}</span>
                </Link>
              </li>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <li>
                <Link to="/parent-list">
                  <i className="bx bx-id-card"></i>
                  <span>{props.t("Parent")}</span>
                </Link>
              </li>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <>
                <li>
                  <Link to="/users">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Users")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/support-staff">
                    <i className="bx bx-support"></i>
                    <span>{props.t("Support Staff")}</span>
                  </Link>
                </li>
              </>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-money"></i>
                  <span>{props.t("Fees and Payments")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/payment-status">
                      <i className="bx bx-id-card"></i>
                      <span>{props.t("Payment Status")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/processing-fees">
                      <i className="bx bx-loader-circle"></i>
                      <span>{props.t("Processing Fees")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/fees-paid">
                      <i className="bx bxs-receipt"></i>
                      <span>{props.t("Approve Screenshots by Parents")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin-manual-payment">
                      <i className="bx bx-credit-card"></i>
                      <span>{props.t("Manual Entries by admin")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/apply-late-fee">
                      <i className="bx bx-time"></i>
                      <span>{props.t("Apply Re-registration Fees")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            {ACCESS.ADMIN_MANAGEMENT_CENTRE_HEAD.includes(userRole) && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-building"></i>
                  <span>{props.t("Organization")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/cluster">
                      <i className="bx bx-network-chart"></i>
                      <span>{props.t("Cluster")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/category">
                      <i className="bx bx-layer"></i>
                      <span>{props.t("Category")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/program-type">
                      <i className="bx bx-list-ul"></i>
                      <span>{props.t("Program Type")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/centre">
                      <i className="bx bx-buildings"></i>
                      <span>{props.t("Centre")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/feestructure">
                      <i className="bx bx-dollar"></i>
                      <span>{props.t("Tuition Fee")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/discount">
                      <i className="bx bx-purchase-tag"></i>
                      <span>{props.t("Discount")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/fees-type">
                      <i className="bx bx-wallet"></i>
                      <span>{props.t("Other Fees")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/academic-year">
                      <i className="fas fa-graduation-cap"></i>
                      <span>{props.t("Academic Year")}</span>
                    </Link>
                  </li>
                  {/* <li className="submenu ">
                    <a href="#" className="d-flex">
                      <i className="bx bx-money"></i>
                      <span>{props.t("Fees Management")}</span>
                      <i className="bx bx-chevron-down"></i>
                    </a>
                    <ul className="submenu-list">
                      <li>
                        <Link to="/fees-type">
                          <i className="bx bx-wallet"></i>
                          <span>{props.t("Other Fees")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/other-fees-due-list">
                          <i className="bx bx-credit-card-front"></i>
                          <span>{props.t(" Other Fees Due List")}</span>
                        </Link>
                      </li>
                    </ul>
                  </li> */}
                  {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
                    <li>
                      <Link to="/payment">
                        <i className="bx bx-money"></i>
                        <span>{props.t("Payment Channel")}</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <li>
                <Link to="/bank-account-detail">
                  <i className="bx bxs-bank"></i>
                  <span>{props.t("Bank Detail")}</span>
                </Link>
              </li>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <>
                <li className="menu-title">{props.t("Settings")}</li>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-cog"></i>
                    <span>{props.t("Application Setting")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/email">
                        <i className="bx bx-mail-send"></i>
                        <span>{props.t("EMail")}</span>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/notification">
                    <i className="bx bx-bell"></i>
                    <span>{props.t("Notification")}</span>
                  </Link>
                </li>
              </>
            )}
            {ACCESS.CENTER_HEAD.includes(userRole) && (
              <li>
                <Link to="/scheduler">
                  <i className="bx bx-time-five"></i>
                  <span>{props.t("Schedule Reminder")}</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
      <CustomModal
        type="confirm"
        isOpen={logoutConfirmOpen}
        toggle={() => setLogoutConfirmOpen(false)}
        onConfirm={() => {
          setLogoutConfirmOpen(false);
          navigate("/logout");
        }}
        showYesButton={true}
        showNoButton={true}
        yesButtonText={props.t("Logout")}
        noButtonText={props.t("Cancel")}
        text={props.t("Are you sure you want to logout?")}
      />
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));